<div class="mb-3">
  @if (!expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(true)">
      <mat-icon class="icon">chevron_right</mat-icon>
      <strong>Expand for Encounter Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(false)">
      <mat-icon class="icon">expand_more</mat-icon>
      <strong>Encounter Eligibility Details</strong>
    </div>
    <div class="content">
      @if (displayCaptureAdminContent) {
        <p>
          If an encounter type is marked as eligible, then encounters for this type will be used to satisfy patient care ownership.
        </p>
        <p>
          If an encounter type is <em>NEW</em> or marked ineligible, encounters for this type will not be used to satisfy patient care ownership.
        </p>
      } @else {
        <p>
          Encounter data shared from your EHR is used to determine patient care ownership and eligibility
          for your 340B claim certifications. We need to ensure only encounter types that prove patient
          care ownership are flagged ELIGIBLE. Encounter types that do not prove patient care ownership
          should be flagged INELIGIBLE. Encounter types flagged NEW should be updated as soon as possible.
        </p>
        <p>
          <strong>
            If an encounter type is marked as <span class="eligibility-status eligible">eligible</span>, then encounters for this type will be used to satisfy patient care ownership.
          </strong>
        </p>
        <p>
          <strong>
            If an encounter type is <span class="eligibility-status new">new</span> or marked <span class="eligibility-status ineligible">ineligible</span>, encounters for this type will not be used to satisfy patient care ownership.
          </strong>
        </p>
      }
    </div>
  }
</div>

